import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {IPhoneNumber, IPhoneNumberCache} from '../../interfaces/phone-number/phone-number.interface';
import {PhoneNumberTypeEnum} from '../../interfaces/phone-number/phone-number-type.enum';
import {NgForm, NgModel} from '@angular/forms';
import {GuidService} from '../../services/guid/guid.service';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {PhoneTypeEnum} from '../../enums/phone';

@Component({
  selector: 'app-phone-section',
  templateUrl: './phone-section.component.html',
  styleUrls: ['./phone-section.component.scss'],
  animations: [fadeInAnimation]
})
export class PhoneSectionComponent implements OnInit, OnChanges {

  /**
   * List of phone numbers
   * @type IPhoneNumber[]
   */
  @Input() phones: IPhoneNumber[];

  /**
   * Required form
   * @type boolean
   * @default true
   */
  @Input() required = true;

  /**
   * Remove class card-container-shadow on the form
   * @type boolean
   * @default false
   */
  @Input() removeClassCardContainerShadow = false;

  @Input() disabled: boolean;
  @Input() limit: number;
  @Input() withoutHeader: boolean;
  @Input() description = '';
  phoneNumberTypes: PhoneNumberTypeEnum[];

  phonesCache: IPhoneNumberCache[] = [];
  @ViewChild('formPhoneNumber') formPhoneNumber: NgForm;

  helperValidationField: HelperValidationField;
  phoneTypes: PhoneTypeEnum[] = [PhoneTypeEnum.CELLULAR, PhoneTypeEnum.FAX, PhoneTypeEnum.LOCAL];
  constructor(
    private guidService: GuidService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.phones) {
      this.init();
    }
  }

  /**
   * Init variables
   * @private
   */
  private init(): void {
    try {
      if (!this.phones) this.phones = [];
      if (this.phones?.length > 0) {
        this.phones = this.phones.map((phone: IPhoneNumber) => ({
          formId: this.guidService.guid(),
          phoneNumberPlaceholder: phone.phoneNumber || '-------',
          phoneNumber: phone.phoneNumber,
          extPlaceholder: phone.ext || '---',
          ext: phone.ext,
          areaCodePlaceholder: phone.areaCode || '---',
          areaCode: phone.areaCode,
          type: phone.type
        }));
      } else if (!this.phones || this.phones.length === 0) {
        this.phones = [this.objNewPhone()];
      }
      this.phoneNumberTypes = Object.values(PhoneNumberTypeEnum);
      this.phones.forEach((_: IPhoneNumber): void => {
        this.phonesCache.push(this.objNewPhoneCache());
      });
      this.helperValidationField = new HelperValidationField();
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Add a new phone object
   */
  onAddPhoneNumber(): void {
    this.phones.push(this.objNewPhone());
    this.phonesCache.push(this.objNewPhoneCache());
  }

  /**
   * Delete a phone
   * @param formId
   */
  onDeletePhoneNumber(formId: string): void {
    this.formPhoneNumber.form.removeControl('phoneNumbers-' + formId);
    const index = this.phones.findIndex((phone) => phone.formId === formId);
    if (index !== -1) {
      this.phones.splice(index, 1);
    }
  }

  /**
   * Returns a new phone cache object
   * @private
   */
  private objNewPhone(_?: IPhoneNumber): IPhoneNumber {
    return {
      formId: this.guidService.guid(),
      phoneNumberPlaceholder: '4567890',
      phoneNumber: '4567890',
      extPlaceholder: '---',
      ext: '',
      areaCodePlaceholder: '123',
      areaCode: '123',
      type: PhoneNumberTypeEnum.CELLULAR,
    };
  }

  /**
   * Returns a new phone object
   * @private
   */
  private objNewPhoneCache(): IPhoneNumberCache {
    return {
      showArea: false,
      showExt: false,
      showNumber: false
    };
  }

  /**
   * método para quitar el foco a las otras partes de los números de teléfono y seleccionar solo
   * el elemento que se quiere modificar
   * @param property propiedad a mostrar y ocultar en el resto de teléfonos
   * @param index indice del teléfono en el arreglo dentro del for
   * @param input elemento input para asignarle el focus
   */
  elementPhoneSelected(property, index, input: HTMLInputElement): void {
    this.phonesCache.forEach(item => item[property] = false);
    this.phonesCache[index][property] = true;
    setTimeout(() => {
      input.focus();
      input.select();
    }, 10);
  }

  /**
   *
   * @param element input
   * @param index index of elemento input
   * @param phone ngModel of phone
   * @param property property of phone model to modify
   * @param placeholder
   * @param propertyShow property to hidde
   * @param valueReset
   */
  onBlurInput(element: NgModel, index: number, phone: IPhoneNumber, property: string, placeholder: string, propertyShow: string, valueReset: string): void {
    if (phone[property].length === 0) {
      // phone[property] = valueReset;
      element.control.markAsDirty();
      element.control.markAsTouched();
      phone[placeholder] = valueReset;
    } else {
      phone[placeholder] = phone[property];
    }
    this.phonesCache[index][propertyShow] = false;
  }
}
